import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

export default ({ children }: Props) => <div className="header-item">{children}</div>;
